
<v-row class="no-frame pb-0 pt-0" v-if="data && data.responsibility" style="display: flex">
    <v-col class="no-frame">
        <v-checkbox
            v-model = "data.selected"
            :label  = "data.responsibility.name"
            :ripple = "false"
            @click  = "onSelected"
            class   = "mt-1 pt-0"
            hide-details
        />
    </v-col>
    <v-col class="no-frame col-auto v-flex">
        <v-radio-group
            v-model   = "type"
            class     = "ma-0"
            :disabled = "!this.data.selected"
            hide-details
            dense
            row
        >
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-radio
                            :ripple = "false"
                            class   = "mt-0 pt-0 ma-0"
                            @click  = "onType"
                            hide-details
                        />
                    </div>
                </template>
                <span >An</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-radio
                            :ripple = "false"
                            class   = "mt-0 pt-0 ma-0"
                            @click  = "onType"
                            color   = "primary lighten-4"
                            hide-details
                        />
                    </div>
                </template>
                <span>CC</span>
            </v-tooltip>
        </v-radio-group>
    </v-col>
</v-row>
